// extracted by mini-css-extract-plugin
export default {"card":"KYpWctVDdeg8vnwbNThF","icon":"VZW5f1HEUBppPh6WALTY","title":"mADTfgnBh93G1ciC4NGw"};